export default __webpack_public_path__ + "static/char-s-48-en-2eca9b42729dda72823c4948f84262f5.png";